export class SortList {
  sort1: string;
  sort2: string;
  sort3: string;
}



// WEBPACK FOOTER //
// ./src/models/sortList.ts